import { getCachedGeocode, setCachedGeocode } from './cache';

const geocode = async (location) => {
  // Cities don't move. Cache forever — saves ~200-400ms per repeat visit
  // to the same city, which is the most common pattern.
  const cached = getCachedGeocode(location);
  if (cached) return cached;

  const encodedLocation = encodeURIComponent(location);
  const response = await fetch(`https://geocoding-api.open-meteo.com/v1/search?name=${encodedLocation}&count=1&language=en&format=json`);
  if (!response.ok) {
    throw new Error('Failed to geocode location');
  }
  const data = await response.json();
  if (!data.results || data.results.length === 0) {
    throw new Error('Location not found');
  }
  const result = {
    latitude: data.results[0].latitude,
    longitude: data.results[0].longitude,
  };
  setCachedGeocode(location, result);
  return result;
};

export default geocode;
